export default __webpack_public_path__ + "static/media/320C.1ef48db1.pdf";